/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.BooksData.type:EntityInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Entity information. Mirrors `csm.booksdb.data.EntityInfo`.
 *******************************************************************************/
OrganizationConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function OrganizationConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.entities.Organization',
    inherits: 'NewBooksData.EntityInfo',
    $type: 'csm.booksdb.data.entities.Organization, CSMBooksDBCS',
    prototype: {
      commonID: 0, // Common ID.
      orgType: null, // Organization Type.
      code: null, // Organization Code.
      fyMonth: 0, // Fiscal Year Start Month.
      fyDay: 0, // Fiscal Year Start Day.
      tyMonth: 0, // Tax Year Start Month.
      tyDay: 0, // Tax Year Start Day.
      taxForm: 0, // Tax Form.
      taxRate: 0, // Sales Tax Rate.
      revTrakSiteKey: null, // RevTrak webstore ID.
      allowSignatures: false, // Allow Signatures flag.
      checkStock: null, // Check stock template name.
      defaultBankID: 0, // Default Bank Account ID.
      unitID: null, // PTA ONLY, Unit ID.
      nationalUnitID: null, // PTA ONLY, National Unit ID.
      stateID: null, // PTA ONLY, State ID (FTD).
      FEIN: null, // PTA ONLY, FEIN.
      exitGrade: 0, // Exit Grade.
      contractDate: null, // Contract Start Date.
      openDate: null // Books Opened Date.
    },
    constructor: function (NewBooksData) {
      return function (data) {
        NewBooksData.EntityInfo.call(this, data);
      };
    }
  });
}
